import { boolean, struct } from 'io-ts/Decoder';

import { iotsUtils } from '@bedc/core';

export const Request = struct({
	pages: iotsUtils.NonEmptyArray(
		struct({
			pageNumber: iotsUtils.PositiveInteger1Based,
			discard: boolean,
		})
	),
});
